/* eslint-disable no-prototype-builtins */
import { Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { NotificationPayload } from '@/models/NotificationPayload';
import { NotificationMessageType } from '@/flightpath-components/models/NotificationMessageType';

@Module({ name: 'notifications' })
export default class NotificationStore extends VuexModule {
  snackbar = false;
  message = '';
  lastModifiedState: { [index: string]: Date } = {};
  updateCounter: { [index: string]: boolean } = {};
  notificationCount: { [index: string]: number } = {};

  @Mutation
  updateCount(payload: NotificationPayload<number>) {
    this.notificationCount[payload.Type] = payload.Value;
  }

  @Mutation
  incrementCount(payload: NotificationMessageType) {
    if (!this.notificationCount.hasOwnProperty(payload.toString())) this.notificationCount[payload] = 1;
    else {
      this.notificationCount[payload] = this.notificationCount[payload] + 1;
    }
  }

  @Mutation
  setSnackbar(snackbar: boolean) {
    this.snackbar = snackbar;
  }

  @Mutation
  setMessage(value: string) {
    this.snackbar = true;
    this.message = value;
  }

  @Mutation
  updateLastModified(view: string) {
    this.lastModifiedState[view] = new Date();
    this.lastModifiedState = Object.assign({}, this.lastModifiedState);
  }
  @Mutation
  updateLastModifiedPayload(payload: NotificationPayload<Date>) {
    this.lastModifiedState[payload.Type] = payload.Value;
    this.lastModifiedState = Object.assign({}, this.lastModifiedState);
  }
  @Mutation
  updateCounterNotification(payload: NotificationPayload<boolean>) {
    this.updateCounter[payload.Type] = payload.Value;
    this.updateCounter = Object.assign({}, this.updateCounter);
  }

  get notifyCounter() {
    return this.updateCounter;
  }

  get newFieldItems(): boolean {
    // eslint-disable-next-line no-prototype-builtins
    if (
      !this.notifyCounter.hasOwnProperty(NotificationMessageType.NewField.toString()) &&
      !this.notifyCounter.hasOwnProperty(NotificationMessageType.ModifiedField.toString())
    )
      return false;
    if (this.notifyCounter.hasOwnProperty(NotificationMessageType.NewField.toString()) && this.notifyCounter[NotificationMessageType.NewField.toString()])
      return this.notifyCounter[NotificationMessageType.NewField.toString()];
    else if (
      this.notifyCounter.hasOwnProperty(NotificationMessageType.ModifiedField.toString()) &&
      this.notifyCounter[NotificationMessageType.ModifiedField.toString()]
    )
      return this.notifyCounter[NotificationMessageType.ModifiedField.toString()];
    return false;
  }

  get newPathItems(): boolean {
    // eslint-disable-next-line no-prototype-builtins
    if (
      !this.notifyCounter.hasOwnProperty(NotificationMessageType.NewPath.toString()) &&
      !this.notifyCounter.hasOwnProperty(NotificationMessageType.ModifiedPath.toString())
    )
      return false;
    if (this.notifyCounter.hasOwnProperty(NotificationMessageType.NewPath.toString()) && this.notifyCounter[NotificationMessageType.NewPath.toString()])
      return this.notifyCounter[NotificationMessageType.NewPath.toString()];
    else if (
      this.notifyCounter.hasOwnProperty(NotificationMessageType.ModifiedPath.toString()) &&
      this.notifyCounter[NotificationMessageType.ModifiedPath.toString()]
    )
      return this.notifyCounter[NotificationMessageType.ModifiedPath.toString()];
    return false;
  }

  get newCompletedMissionItems(): boolean {
    // eslint-disable-next-line no-prototype-builtins
    if (!this.notifyCounter.hasOwnProperty(NotificationMessageType.MissionCompleted.toString())) return false;
    return this.notifyCounter[NotificationMessageType.MissionCompleted.toString()] ?? false;
  }
  get newCancelledMissionItems(): boolean {
    // eslint-disable-next-line no-prototype-builtins
    if (!this.notifyCounter.hasOwnProperty(NotificationMessageType.MissionCancelled.toString())) return false;
    return this.notifyCounter[NotificationMessageType.MissionCancelled.toString()] ?? false;
  }
  get newInProgressMissionItems(): boolean {
    // eslint-disable-next-line no-prototype-builtins
    if (!this.notifyCounter.hasOwnProperty(NotificationMessageType.MissionStart.toString())) return false;
    return this.notifyCounter[NotificationMessageType.MissionStart.toString()] ?? false;
  }

  get totalNotifications(): number {
    let count = 0;
    for (const key in this.notificationCount) {
      if (Object.prototype.hasOwnProperty.call(this.notificationCount, key)) {
        const element: number = this.notificationCount[key];
        count += element;
      }
    }
    return count;
  }
}
